const UPDATE_MENU = 'UPDATE_MENU';
const UPDATE_ARTICLE = 'UPDATE_ARTICLE';
export const addArticle = article => ({ type: UPDATE_ARTICLE, payload: article });
export const setMenu = menu => ({ type: UPDATE_MENU, payload: menu });